// /components/auth/prefetchAuthChunks.ts
let prefetched: Promise<unknown> | null = null;

export function prefetchAuthChunks() {
  if (!prefetched) {
    prefetched = Promise.all([
      import('./../../components/forms/AuthModal'), // ✅ добавили
      import('./../../components/forms/LoginForm'),
      import('./../../components/forms/RegisterForm'),
      import('./../../components/forms/VerificationForm'),
      import('./../../components/forms/ForgotPasswordForm'),
    ]).catch(() => {
      prefetched = null;
    });
  }
  return prefetched;
}
